import {
  Box,
  Button,
  Card,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import globalStyles from "../../../global";
import FooterSr from "../components/Footersr";
import News from "../../../components/globalCountries/countryhomepagescomponent/News";
import FreeDeliveryBannerSr from "../components/Freedeliverysr";
import { useTranslation } from "react-i18next";
const MediacoverageSr = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: "#f3f4f6",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "280px", md: "440px" },
          bgcolor: "#F2F3F0",
        }}
      >
        <Box
          component="img"
          src={`${imageBaseUrl}media.svg`}
          alt={t("locateUs.alt.banner")}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            left: 0,
            top: 0,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 10,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              textTransform: "uppercase",
              textAlign: "center",
              textShadow: "0 2px 8px rgba(0,0,0,0.26)",
              fontFamily: globalStyles.fonts.primaryUAE,
              fontWeight: 500,
              fontSize: {
                md: "55px",
                sm: "36px",
                xs: "30px",
              },
              lineHeight: "60px",
              letterSpacing: "1%",
              color: globalStyles.colors.army_green,
              px: 2,
            }}
          >
            {t("media.bannerText")}
          </Typography>
        </Box>
      </Box>

      <Box className="container" sx={{ mx: "auto", px: 2, pt: 8, pb: 4 }}>
        <Box
          component="form"
          sx={{ display: "flex", justifyContent: "center", mb: 8 }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              maxWidth: "781.2px",
              height: "60px",
              flexDirection: "row",
              position: "relative",
            }}
          >
            {/* Input Container with Icons */}
            <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
              {/* Left Search Icon */}
              <Box
                component="img"
                src={`${imageBaseUrl}search-left.png`}
                alt="Search Icon"
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "12px",
                  transform: "translateY(-50%)",
                  width: "20px",
                  height: "20px",
                  pointerEvents: "none",
                }}
              />

              {/* Input */}
              <Box
                component="input"
                type="text"
                placeholder={t("media.search.placeholder")}
                sx={{
                  width: "100%",
                  height: "100%",
                  pl: "42px",
                  pr: "42px",
                  border: "1.2px solid #BBBBBB",
                  borderRadius: "12px",
                  fontSize: { sm: "18px", xs: "14px" },
                  outline: "none",
                  background: "#fff",
                  textAlign: "left",
                }}
              />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "30px",
            mt: "60px",
            // px: 2,
          }}
        >
          {[1, 2, 3, 4].map((item) => (
            <Card
              key={item}
              sx={{
                width: "100%",
                maxWidth: "1200px",
                border: "1px solid #E0E0E0",
                borderRadius: "10px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                py: 5,
                px: {
                  sm: 5,
                  xs: 3,
                },
                transition: "all 0.3s ease",
                cursor: "pointer",
                "&:hover": {
                  border: "1px solid #174C2E",
                  boxShadow: "1px 1px 25px 0px #0000001A",
                  backgroundColor: "#F0FFF5", // light green background
                },
              }}
            >
              <Grid container spacing={4} alignItems="start">
                {/* Left: Logo */}
                <Grid
                  item
                  xs={12}
                  md={2}
                  sx={
                    {
                      // display: "flex",
                      // justifyContent: "start",
                      // alignItems: "start",
                    }
                  }
                >
                  <Box
                    component="img"
                    src={`${imageBaseUrl}dna-logo.png`} // Replace with actual image
                    alt="DNA Logo"
                    sx={{ width: "150px", height: "auto" }}
                  />
                </Grid>

                {/* Right: Text Content */}
                <Grid item xs={12} md={10}>
                  <Typography
                    sx={{
                      fontSize: { md: "30px", sm: "24px", xs: "20px" },
                      fontWeight: 600,
                      lineHeight: "40px",
                      fontFamily: globalStyles.fonts.primary,
                      color: globalStyles.colors.text_green,
                      mb: 1,
                    }}
                  >
                    MEET IT GRADUATE, WHO LEFT RS 84 LAKH JOB TO BUILD RS 100
                    CRORE COMPANY WITH HIS WIFE
                  </Typography>

                  <Typography
                    sx={{
                      width: "225px",
                      height: "38px",
                      opacity: 0.75,
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: { sm: "12px", xs: "9px" },
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      color: "#4F4F4F", // adjusted for better contrast, or keep '#888' if needed
                      mb: 1,
                      mt: 2,
                    }}
                  >
                    Date Posted: February 16, 2024
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { sm: "18px", xs: "14px" },
                      lineHeight: "24px",
                      color: "#4F4F4F",
                      letterSpacing: "0%",
                      fontWeight: 400,
                      mb: 4,
                      fontFamily: globalStyles.fonts.primary,
                      textAlign: "justify",
                    }}
                  >
                    One who ventures into unexplored markets and finds success
                    there is a brilliant entrepreneur. Laundry takes a lot of
                    work, as anyone who lives alone can attest. Gunjan Taneja
                    became aware of the unpleasant fact that laundry is a major
                    task. Anurabh Sinha, a Bihar native, and his wife Gunjan
                    Sinha started a laundry business...
                  </Typography>

                  <Button
                    variant="contained"
                    sx={{
                      width: "186px",
                      height: "45px",
                      gap: "10px",
                      borderRadius: "10px",
                      paddingTop: "15px",
                      paddingRight: "10px",
                      paddingBottom: "15px",
                      paddingLeft: "10px",
                      //backgroundColor: "#DEF1D8",
                      backgroundColor: "#FFF",
                      color: "#65BA0D",
                      fontSize: { sm: "18px", xs: "14px" },
                      fontFamily: "Poppins",
                      textTransform: "none",
                      fontWeight: 600,
                      border: "1px solid #65BA0D",
                      boxShadow: "0px 4px 4px 0px #00000014",
                      "&:hover": {
                        backgroundColor: "#DEF1D8",
                        border: "1px solid #65BA0D",
                        // boxShadow: "none",
                        boxShadow: " 0px 2px 4px rgba(0, 0, 0, 0.05)",
                      },
                    }}
                  >
                    Read More
                  </Button>
                </Grid>
              </Grid>
            </Card>
          ))}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            justifyContent: "center",
            mt: 7,
          }}
        >
          <Button
            disabled
            sx={{
              borderRadius: "9.6px",
              py: "12px",
              px: "4.8px",
              fontWeight: 600,
               fontSize: {sm:"15.6px",xs:"12px"},
              lineHeight: "100%",
              letterSpacing: "0%",
              color: "#333333",
              transition: "all 0.3s ease",
              "&:hover": {
                color: globalStyles.colors.text_green,
              },
            }}
          >
            Prev
          </Button>

          {[1, 2, 3, 4, 5]
            ?.filter((x) => (isMobile ? x <= 2 : true))
            ?.map((e) => (
              <Button
                sx={{
                  height: "38.5px",
                  width: "38.5px",
                  minWidth: "38.5px",
                  borderRadius: "9.6px",
                  borderWidth: "1.2px",
                  // py: "18px",
                  padding: "12   px",
                  border: "1.2px solid #eaeaea",
                  fontWeight: 600,
                   fontSize: {sm:"15.6px",xs:"12px"},
                  lineHeight: "100%",
                  letterSpacing: "0%",
                  color: e === 1 ? "#FFF" : "#333333",
                  backgroundColor:
                    e === 1 ? globalStyles.colors.uclean_secondary : "#FFF",
                  transition: "all 0.3s ease",
                  boxShadow: "0px 1px 1px 0px #00000008",
                  "&:hover": {
                    color: "#FFF",
                    backgroundColor: globalStyles.colors.uclean_secondary,
                  },
                }}
              >
                {e}
              </Button>
            ))}
          <Typography
            sx={{
              fontWeight: 600,
               fontSize: {sm:"15.6px",xs:"12px"},
              lineHeight: "100%",
              letterSpacing: "0%",
              color: "#333333",
            }}
          >
            ...
          </Typography>
          <Button
            sx={{
              height: "38.5px",
              width: "38.5px",
              minWidth: "38.5px",
              borderRadius: "9.6px",
              borderWidth: "1.2px",
              // py: "18px",
              padding: "12   px",
              border: "1.2px solid #eaeaea",
              color: "#333333",
              backgroundColor: "#FFF",
              fontWeight: 600,
               fontSize: {sm:"15.6px",xs:"12px"},
              lineHeight: "100%",
              letterSpacing: "0%",
              transition: "all 0.3s ease",
              boxShadow: "0px 1px 1px 0px #00000008",
              "&:hover": {
                color: "#FFF",
                backgroundColor: globalStyles.colors.uclean_secondary,
              },
            }}
          >
            12
          </Button>
          <Button
            sx={{
              borderRadius: "9.6px",
              py: "12px",
              px: "4.8px",
              fontWeight: 600,
              fontSize: {sm:"15.6px",xs:"12px"},
              lineHeight: "100%",
              letterSpacing: "0%",
              color: "#333333",
              transition: "all 0.3s ease",
              "&:hover": {
                color: globalStyles.colors.text_green,
              },
            }}
          >
            Next
          </Button>
        </Box>
      </Box>

      <FreeDeliveryBannerSr />
      <News />
      <Box sx={{ height: "80px" }} />
      <FooterSr />
    </Box>
  );
};
export default MediacoverageSr;
